// extracted by mini-css-extract-plugin
export default {"modalCustomizeContainer":"ModalCustomize_modalCustomizeContainer__wLmtv","itemsContainer":"ModalCustomize_itemsContainer__-KVKg"};